<template>
  <div>
    <div class="toolbar">
      <el-select v-model="supplierId" clearable filterable placeholder="供应商" style="width:200px">
        <el-option v-for="s in suppliers" :key="s.id" :label="s.name" :value="s.id" />
      </el-select>
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        value-format="yyyy-MM-dd"
        start-placeholder="申请开始"
        end-placeholder="申请结束"
        style="width:260px"
      />
      <el-date-picker
        v-model="receiveRange"
        type="daterange"
        value-format="yyyy-MM-dd"
        start-placeholder="送货开始"
        end-placeholder="送货结束"
        style="width:260px"
      />
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
      <el-button icon="el-icon-download" :loading="exporting" :disabled="!list.length" @click="onExport">导出</el-button>
    </div>
    <el-table :data="pageList" border v-loading="loading" show-summary :summary-method="summaryMethod">
      <el-table-column prop="supplierName" label="供应商" min-width="200" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <el-button type="text" @click="openDetail(row)">{{ row.supplierName || '-' }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="salesAmount" label="总金额" width="160" align="right">
        <template slot-scope="{ row }">{{ money(row.salesAmount) }}</template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="listTotal"
      :page="page"
      :page-size="pageSize"
      @current-change="onPageChange"
      @size-change="onPageSizeChange"
    />

    <el-dialog
      :title="detailTitle"
      :visible.sync="detailVisible"
      width="760px"
      top="6vh"
      append-to-body
    >
      <el-table :data="detailList" border v-loading="detailLoading" max-height="520" show-summary :summary-method="detailSummary">
        <el-table-column prop="materialName" label="材料名称" min-width="180" show-overflow-tooltip />
        <el-table-column prop="unit" label="单位" width="80" />
        <el-table-column prop="qty" label="销量" width="120" align="right">
          <template slot-scope="{ row }">{{ money(row.qty) }}</template>
        </el-table-column>
        <el-table-column prop="salesAmount" label="销售金额" width="140" align="right">
          <template slot-scope="{ row }">{{ money(row.salesAmount) }}</template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { supplierSalesReport, exportSupplierSalesReport, supplierSalesDetail } from '../../api/report'
import { listSuppliers } from '../../api/supply'
import ListPagination from '../../components/ListPagination.vue'
import listPaging from '../../mixins/listPaging'
import { monthRange, money, num, downloadXlsx } from './format'

export default {
  name: 'SupplierSalesReport',
  components: { ListPagination },
  mixins: [listPaging],
  data() {
    const range = monthRange()
    return {
      supplierId: null,
      dateRange: [range.startDate, range.endDate],
      receiveRange: [],
      suppliers: [],
      list: [],
      loading: false,
      exporting: false,
      detailVisible: false,
      detailLoading: false,
      detailTitle: '',
      detailList: []
    }
  },
  created() {
    this.loadSuppliers()
    this.load()
  },
  methods: {
    money,
    queryParams() {
      return {
        supplierId: this.supplierId || undefined,
        startDate: this.dateRange && this.dateRange[0],
        endDate: this.dateRange && this.dateRange[1],
        receiveStartDate: this.receiveRange && this.receiveRange[0],
        receiveEndDate: this.receiveRange && this.receiveRange[1]
      }
    },
    async loadSuppliers() {
      const res = await listSuppliers({})
      this.suppliers = res.data || []
    },
    async load() {
      this.loading = true
      try {
        const res = await supplierSalesReport(this.queryParams())
        this.list = (res.data && res.data.list) || []
        this.page = 1
      } finally {
        this.loading = false
      }
    },
    async onExport() {
      if (!this.list.length) {
        return this.$message.warning('暂无数据可导出')
      }
      this.exporting = true
      try {
        const res = await exportSupplierSalesReport(this.queryParams())
        downloadXlsx(res.data, '供应商销量.xlsx')
      } catch (e) {
        this.$message.error('导出失败')
      } finally {
        this.exporting = false
      }
    },
    async openDetail(row) {
      if (!row.supplierId) return
      this.detailTitle = `供应商销量明细 - ${row.supplierName || ''}`
      this.detailVisible = true
      this.detailLoading = true
      this.detailList = []
      try {
        const res = await supplierSalesDetail({
          supplierId: row.supplierId,
          startDate: this.dateRange && this.dateRange[0],
          endDate: this.dateRange && this.dateRange[1],
          receiveStartDate: this.receiveRange && this.receiveRange[0],
          receiveEndDate: this.receiveRange && this.receiveRange[1]
        })
        this.detailList = (res.data && res.data.list) || []
      } catch (e) {
        this.$message.error('加载明细失败')
      } finally {
        this.detailLoading = false
      }
    },
    detailSummary({ columns }) {
      const data = this.detailList || []
      const amount = data.reduce((s, r) => s + num(r.salesAmount), 0)
      const qty = data.reduce((s, r) => s + num(r.qty), 0)
      return columns.map((col, i) => {
        if (i === 0) return '合计'
        if (col.property === 'salesAmount') return money(amount)
        if (col.property === 'qty') return money(qty)
        return ''
      })
    },
    summaryMethod({ columns }) {
      const data = this.list || []
      const amount = data.reduce((s, r) => s + num(r.salesAmount), 0)
      return columns.map((col, i) => {
        if (i === 0) return '合计'
        if (col.property === 'salesAmount') return money(amount)
        return ''
      })
    }
  }
}
</script>

<style scoped>
.toolbar { display:flex; gap:8px; margin-bottom:12px; flex-wrap:wrap; }
</style>
